import { PROFILE_FIELDS, type FieldMeta } from '@accheyrishtey/shared';

export interface FilterBinding {
  field: FieldMeta;
  kind: 'multi' | 'text' | 'range';
  params: readonly string[];
  label?: string;
}

const aliases: Record<string, string> = {
  full_name: 'name', contact_number: 'contact', education_qualification: 'education',
  what_do_you_do: 'occupation', hobbies_interests: 'hobbies',
  residential_address: 'address', father_contact_number: 'father_contact',
  mother_contact_number: 'mother_contact',
};

const rangeParams: Record<string, readonly [string, string]> = {
  date_of_birth: ['age_min', 'age_max'], height_cm: ['height_min', 'height_max'],
  number_of_sisters: ['sisters_min', 'sisters_max'],
  number_of_brothers: ['brothers_min', 'brothers_max'],
  pref_age_min: ['pref_age_min_from', 'pref_age_min_to'],
  pref_age_max: ['pref_age_max_from', 'pref_age_max_to'],
  pref_height_cm: ['pref_height_min', 'pref_height_max'],
};

export const FILTER_BINDINGS: FilterBinding[] = PROFILE_FIELDS.map((field) => {
  const range = rangeParams[field.key];
  if (range) {
    return {
      field, kind: 'range', params: range,
      label: field.key === 'date_of_birth' ? 'Age' : field.label,
    };
  }
  return {
    field,
    kind: field.filter === 'multi' ? 'multi' : 'text',
    params: [aliases[field.key] ?? field.key],
  };
});

export const EXTRA_FILTERS = [
  { key: 'starred', label: 'Starred only' },
  { key: 'has_photo', label: 'Has photograph' },
  { key: 'has_notes', label: 'Has private notes' },
] as const;

export const FILTER_PARAM_KEYS = new Set([
  ...FILTER_BINDINGS.flatMap((binding) => binding.params),
  ...EXTRA_FILTERS.map((filter) => filter.key),
  'submitted_from', 'submitted_to',
]);
